import { Optional } from 'frontend/types';

export function setVh() {
  const vh = `${window.innerHeight / 100}px`;
  document.documentElement.style.setProperty('--vh', `${vh}`);
  return vh;
}

export function setAppTagOverflow(value: string): string {
  const app = document.getElementById('app');
  let previousValue = '';
  if (app) {
    previousValue = app.style.overflow;
    app.style.overflow = value;
  }
  return previousValue;
}

export function safeWindow(): Optional<Window> {
  if (process.env.VUE_ENV === 'server' || typeof window === 'undefined') {
    return undefined;
  }
  return window;
}

export function safeLocalStorage(): Optional<Storage> {
  if (process.env.VUE_ENV === 'server' || typeof localStorage === 'undefined') {
    return undefined;
  }
  return localStorage;
}

export function safeSessionStorage(): Optional<Storage> {
  if (process.env.VUE_ENV === 'server' || typeof sessionStorage === 'undefined') {
    return undefined;
  }
  return sessionStorage;
}
